module.exports = __webpack_public_path__ + "img/logo_button.c38945e4.png";